import { IPrice } from 'modules/formatter/types';
import { Regex } from 'modules/validation';

export const getCurrencySymbol = (locale: string, currency: string) =>
  (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim();

/**
 *
 * @param amount - in cents
 * @param locale
 * @param currencyCode
 * @returns
 */
export const getPrice = (
  amount: number,
  locale: string,
  currencyCode: string,
): IPrice => {
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const toDecimal = formatter.format(amount / 100);
  const currency = getCurrencySymbol(locale, currencyCode);

  return {
    value: `${toDecimal} ${currency}`,
    amount: toDecimal,
    currency,
  };
};

export const getRegexForCheckEmail = (email: string): RegExp => {
  const username = email?.match(Regex.emailUsername)?.[1];
  const domain = email?.match(Regex.emailDomain)?.[1];
  const domainWithoutAt = email?.match(Regex.emailDomainWithoutAt)?.[0];
  const prefix = email?.match(Regex.emailPrefix)?.[0];
  const domainPrefix = email?.match(Regex.domainPrefix)?.[1];

  const checkingString: string = (
    [username, prefix, domain, domainWithoutAt, domainPrefix]?.reduce(
      (acc, str, currentIndex) => {
        if (!str) {
          return acc;
        }

        return acc + (currentIndex > 0 ? `|${str}` : str);
      },
      '',
    ) as string
  )?.replace(/[.{}()|[\]\\]/g, '\\$&');

  return Regex.notMatchWithString(checkingString);
};

export const getPercentagesOfValidationPassword = (
  password: string,
  email?: string,
): number => {
  const checkWithEmail = (regex: RegExp) =>
    email ? [getRegexForCheckEmail(email), regex] : regex;

  const conditions = [
    Regex.notEmpty,
    [Regex.minPasswordLength, Regex.hasNumber],
    checkWithEmail(Regex.password),
    checkWithEmail(Regex.hardPassword),
  ];

  const result = conditions.reduce<number>((acc, regex) => {
    let resultConditionsArray = false;
    let resultCondition = false;

    if (Array.isArray(regex)) {
      resultConditionsArray = regex.every((a) => a.test(password));
    } else {
      resultCondition = regex.test(password);
    }
    return resultConditionsArray || resultCondition
      ? acc + 100 / conditions.length
      : acc;
  }, 0);

  return Number(result.toFixed(0));
};
